import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumEditForm4DistributionPopup1({
  onClose,
  onNext,
} : {
  onClose: () => void,
  onNext: () => void,
}) {
  return (
    <PopupContainer title="音楽配信サービス" onClose={() => { onClose(); }}>
      <div className="list__body album_delivery">
        <p>
          世界中の各社が運営するダウンロード販売サービスや、ストリーミングサービスに、このリリースを配信します。
          <br />
          <br />
          配信に費用はかかりません。
          <br />
          各ストアから還元される売上の60％をお支払いいたします。
        </p>
        <br />
        <p className="store_list">【配信先ストア一覧】</p>
        <ul className="store_list_inner">
          <li>
            iTunes Store / Apple Music
            <small>（Apple）</small>
          </li>
          <li>
            music.jp STORE
            <small>（MTI）</small>
          </li>
          <li>
            oricon ME!
            <small>（oricon ME）</small>
          </li>
          <li>
            Spotify
            <small>（Spotify）</small>
          </li>
          <li>
            KKBOX
            <small>（KKBOX）</small>
          </li>
          <li>
            うたパス
            <small>（KDDI）</small>
          </li>
          <li>
            レコチョク
            <small>（レコチョク）</small>
          </li>
          <li>
            mora
            <small>（レーベルゲート）</small>
          </li>
          <li>
            Media Do
            <small>（Media Do）</small>
          </li>
          <li>
            LINE MUSIC
            <small>（LINE）</small>
          </li>
          <li>
            AWA
            <small>（Avex、サイバーエージェント）</small>
          </li>
          <li>
            SMART USEN
            <small>（USEN）</small>
          </li>
          <li>
            dwango.jp
            <small>（ドワンゴ）</small>
          </li>
          <li>
            OTOTOY
            <small>（オトトイ）</small>
          </li>
          <li>
            Rakuten Music
            <small>（楽天）</small>
          </li>
          <li>
            mysound
            <small>（ヤマハ）</small>
          </li>
          <li>
            DEEZER
            <small>（Deezer）</small>
          </li>
          <li>
            着信★うた♪by KONAMI
            <small>（KONAMI）</small>
          </li>
          <li>
            Gracenote
            <small>（Gracenote）</small>
          </li>
          <li>
            Shazam
            <small>（Shazam Entertainment）</small>
          </li>
          <li>
            YouTube Music
            <small>（YouTube）</small>
          </li>
          <li>
            PlayNetwork
            <small>（PlayNetwork）</small>
          </li>
          <li>
            Tencent
            <small>（TENCENT MUSIC ENTERTAINMENT）</small>
          </li>
          <li>
            NetEase Music
            <small>（NetEase Cloud Music）</small>
          </li>
          <li>
            JOOX
            <small>（Tencent Mobility Limited）</small>
          </li>
          <li>
            FLO
            <small>（Dreamus Company）</small>
          </li>
          <li>
            TuneCore
            <small>（TuneCore Japan）</small>
          </li>
        </ul>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => { onClose(); }}>キャンセル</CustomButton>
            <CustomButton type="default-split" onClick={() => { onNext(); }}>次へ</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
